var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { INJECT_UICORE_DESIGNER, INJECT_UICORE_RENDERER } from "../../../../lib/utils/consts";
import { makeEvalFn } from "../../../../lib/utils/stringInterop";
let ConditionalContainer = class ConditionalContainer extends Vue {
  constructor() {
    super(...arguments);
    this.getCurrentBranchId = () => undefined;
    /** 设计模式用的，强行指定哪一个分支 */
    this.forceBranchIndex = 0;
    /** 设计模式下 默认隐藏切换分支的小按钮 */
    this.showConditionalContainerBranchTab = false;
    this.keepAliveSlotIds = [];
  }
  get currentBranchId() {
    return this.getCurrentBranchId() || 0;
  }
  get currentSlotId() {
    return `branch-${this.currentBranchId}`;
  }
  created() {
    this.isDesignMode = !!this.$attrs['data-uc-design-mode'];
    if (this.isDesignMode) {
      // 设计模式下，要自动清理无用的分支列表
      this.$watch(() => !!this.$attrs['data-uc-selected'] && this.branches.map(b => b.id).join('\n'), ok => {
        var _this$designer$active;
        if (ok === false) return;
        const branchIds = this.branches.map(b => b.id);
        const slotIds = Object.keys(((_this$designer$active = this.designer.activeComp) === null || _this$designer$active === void 0 ? void 0 : _this$designer$active.slots) || {}).filter(k => {
          if (!k.startsWith('branch-')) return false;
          const id = +k.slice(7);
          if (!id) return false; // 兜底分支不删除
          return !branchIds.includes(id);
        });
        if (slotIds.length > 0) {
          this.designer.modifyActiveComp(comp => {
            slotIds.forEach(id => {
              delete comp.slots[id];
            });
          });
        }
      });
    }
    this.$watch(() => this.branches.map(b => `${b.id}:${b.expr}`).join('\n'), () => {
      // 动态的编译并生成 getCurrentBranchId 函数
      const fns = this.branches.map(branch => ({
        fn: makeEvalFn(branch.expr, 1),
        branchId: branch.id
      }));
      this.getCurrentBranchId = () => {
        const {
          renderer
        } = this;
        let ans;
        fns.some(ctx => {
          const temp = ctx.fn.call(renderer, renderer);
          ans = temp ? ctx.branchId : undefined;
          return !!ans;
        });
        return ans;
      };
    }, {
      immediate: true
    });
    this.$watch(() => this.branches.length, length => {
      if (this.forceBranchIndex > length) this.forceBranchIndex = 0;
    });
    if (!this.isDesignMode) {
      this.$watch(() => this.currentSlotId, () => {
        if (!this.keepAliveSlotIds.includes(this.currentSlotId)) {
          this.keepAliveSlotIds.push(this.currentSlotId);
        }
      }, {
        immediate: true
      });
    }
  }
  getBranchIds() {
    const ids = Object.keys(this.$slots || {}).filter(id => id.startsWith('branch-'));
    return ids;
  }
  /**
   * 设计模式使用的，切到前一个分支
   */
  goPrevBranch() {
    if (this.forceBranchIndex <= 0) this.forceBranchIndex = this.branches.length;else this.forceBranchIndex -= 1;
  }
  /**
   * 设计模式使用的，切到下一个分支
   */
  goNextBranch() {
    if (this.forceBranchIndex >= this.branches.length) this.forceBranchIndex = 0;else this.forceBranchIndex += 1;
  }
  renderKeepAliveContent() {
    const h = this.$createElement;
    const {
      keepAliveMode,
      currentSlotId
    } = this;
    let ids = [];
    if (keepAliveMode === 'all') {
      ids = this.getBranchIds();
    } else {
      // lazy
      ids = this.keepAliveSlotIds;
    }
    const content = ids.map(id => {
      const isShow = currentSlotId === id;
      return h("uc-slot", {
        "directives": [{
          name: "show",
          value: isShow
        }],
        "attrs": {
          "name": id
        }
      });
    });
    return h("div", {
      "class": "uc-slotForBlocks w-conditionalContainer"
    }, [content]);
  }
  render() {
    const h = arguments[0];
    if (!this.isDesignMode) {
      const {
        currentSlotId
      } = this;
      if (this.keepAlive) {
        return this.renderKeepAliveContent();
      }
      return h("div", {
        "class": "uc-slotForBlocks w-conditionalContainer",
        "key": currentSlotId
      }, [this.$slots[currentSlotId]]);
    }
    // ------------- 以下为设计模式的 ---------------
    if (this.showMulti) {
      return h("div", {
        "class": "w-conditionalContainer"
      }, [' ', [null, ...this.branches].map((branch, index) => h("div", {
        "class": "w-conditionalContainer-multi"
      }, [h("div", {
        "class": "w-conditionalContainer-multi-title"
      }, [index ? `[${index}]${branch === null || branch === void 0 ? void 0 : branch.name}` : '兜底逻辑']), h("div", {
        "class": "uc-slotForBlocks w-conditionalContainer-multi-content",
        "key": `branch-${(branch === null || branch === void 0 ? void 0 : branch.id) || 0}`,
        "ref": `branch-${(branch === null || branch === void 0 ? void 0 : branch.id) || 0}`
      }, [this.$slots[`branch-${(branch === null || branch === void 0 ? void 0 : branch.id) || 0}`] || h("div", {
        "class": "w-conditionalContainer-placeholder"
      }, ["\u5728\u5C5E\u6027\u9762\u677F\u53EF\u914D\u7F6E\u5206\u652F\u6761\u4EF6\u3002\u5F53\u6761\u4EF6\u6EE1\u8DB3\u65F6\uFF0C\u5C06\u5C55\u793A\u5BF9\u5E94\u5206\u652F\u7684\u5185\u5BB9"])])]))]);
    }
    const branch = this.branches[this.forceBranchIndex];
    return h("div", {
      "class": "uc-slotForBlocks w-conditionalContainer",
      "key": `branch-${(branch === null || branch === void 0 ? void 0 : branch.id) || 0}`,
      "ref": `branch-${(branch === null || branch === void 0 ? void 0 : branch.id) || 0}`
    }, [h("div", {
      "directives": [{
        name: "show",
        value: this.showConditionalContainerBranchTab
      }],
      "class": "w-conditionalContainer-branchTab",
      "attrs": {
        "uc-designer-interactive": "true"
      }
    }, [h("div", {
      "class": "w-conditionalContainer-branchTabButton",
      "on": {
        "click": this.goPrevBranch
      }
    }, [h("i", {
      "class": "fa fa-caret-left"
    })]), h("div", {
      "class": "w-conditionalContainer-branchTabButton",
      "on": {
        "click": this.goNextBranch
      }
    }, [h("i", {
      "class": "fa fa-caret-right"
    })]), branch ? `分支 #${this.forceBranchIndex + 1}` : '兜底分支', !!branch && h("div", {
      "class": "w-conditionalContainer-branchExpr"
    }, [String((branch === null || branch === void 0 ? void 0 : branch.name) || (branch === null || branch === void 0 ? void 0 : branch.expr))])]), this.$slots[`branch-${(branch === null || branch === void 0 ? void 0 : branch.id) || 0}`] || h("div", {
      "class": "w-conditionalContainer-placeholder"
    }, ["\u5728\u5C5E\u6027\u9762\u677F\u53EF\u914D\u7F6E\u5206\u652F\u6761\u4EF6\u3002\u5F53\u6761\u4EF6\u6EE1\u8DB3\u65F6\uFF0C\u5C06\u5C55\u793A\u5BF9\u5E94\u5206\u652F\u7684\u5185\u5BB9"])]);
  }
};
ConditionalContainer = __decorate([Component({
  name: 'ConditionalContainer',
  inject: {
    renderer: {
      from: INJECT_UICORE_RENDERER
    },
    designer: {
      from: INJECT_UICORE_DESIGNER,
      default: null
    }
  },
  props: {
    branches: {
      type: Array,
      required: true
    },
    showMulti: {
      type: Boolean,
      default: false
    },
    keepAlive: {
      type: Boolean,
      default: false
    },
    keepAliveMode: {
      type: String,
      default: 'lazy'
    }
  }
})], ConditionalContainer);
export default ConditionalContainer;
//# sourceMappingURL=index.js.map
